import notificationSound from '../../../images/Chatbot/assets/notification-sound.wav';

export const playNotificationSound = () => {
  const audio = new Audio(notificationSound);
  audio.play().catch((error) => {
    // Silently handle any autoplay restrictions
    console.log('Audio playback error:', error);
  });
};
